import React, { forwardRef, useContext } from "react";

import FormContext from "./FormContext";
import { getHelperText, getValue } from "./helpers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
    DatePicker,
    DatePickerProps,
    LocalizationProvider,
} from "@mui/x-date-pickers";
import { FormControl, FormHelperText } from "@mui/material";
import moment from "moment";
export interface IGPDatePicker extends Omit<DatePickerProps<any>, "onChange"> {
    errorText?: string;
    id: string;
    onChange?: Function;
    regex?: string;
    helperText?: string;
    fullWidth?: boolean;
    format: string;
}

const GPDatePicker = forwardRef<any, IGPDatePicker>((props, ref) => {
    const {
        errorText,
        format,
        fullWidth,
        helperText,
        id,
        onChange,
        sx,
        value,
        ...restProps
    } = props;

    const context = useContext(FormContext);

    const onChangeValue = (dateValue: any) => {
        const val = !isNaN(dateValue.$d.getTime())
            ? moment((dateValue as any).$d.toISOString()).format("YYYY-MM-DD")
            : null;

        if (!!onChange) {
            onChange({ id, value: val }, context);
        } else {
            context?.onChange({ id, value: val });
        }
    };

    const { inputHelperText, isError } = getHelperText(
        id,
        context,
        errorText,
        helperText
    );

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <FormControl fullWidth={fullWidth} sx={sx} error={isError}>
                <DatePicker
                    {...restProps}
                    sx={{
                        height: 40,
                        width: "100%",

                        pr: 0,
                        ".MuiInputBase-root": {
                            height: 40,
                            width: "100%",
                            // fontSize: 13,
                        },
                        ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                                borderColor: "#36845B",
                            },
                    }}
                    value={
                        getValue(id, context, value)
                            ? dayjs(getValue(id, context, value), "YYYY-MM-DD")
                            : ""
                    }
                    onChange={onChangeValue}
                    inputRef={ref}
                    format={format}
                />
                {inputHelperText.length > 0 && (
                    <FormHelperText>{inputHelperText}</FormHelperText>
                )}
            </FormControl>
        </LocalizationProvider>
    );
});

GPDatePicker.defaultProps = {
    errorText: "",
    helperText: "",
};

export default GPDatePicker;
